import { render, staticRenderFns } from "./TypeButton.vue?vue&type=template&id=7dab98e0&"
import script from "./TypeButton.vue?vue&type=script&lang=js&"
export * from "./TypeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports